// XOÁ KỊCH BẢN ngay ở danh sách + THÙNG RÁC (06/10/2026) — phần giao diện của server/src/kich-ban-thung-rac.ts.
// Người dùng có nhiều kịch bản rác: mỗi dòng có nút Xoá + ô tick; tick nhiều / "Chọn tất cả" → thanh nổi "Đã chọn N · Xoá đã chọn · Bỏ chọn".
// Xoá = chuyển vào Thùng rác (giữ 30 ngày, khôi phục được) → hộp xác nhận TỰ VẼ (không dùng confirm() của trình duyệt) nêu số lượng + tên
// (tối đa 5 rồi "và N kịch bản khác"), cảnh báo kịch bản đang nằm trong chuỗi / lịch / gói seeding, và CHẶN kịch bản đang chạy trên bot (máy chủ
// vẫn kiểm lại). Xoá xong: thanh "Đã xoá N kịch bản · Hoàn tác" (còn tới khi rời trang / tự đóng). Mọi chữ dựng bằng textContent (tên có ký tự đặc biệt an toàn).
import { api, errMsg } from "../api";
import { clear, h, svg, toast } from "../dom";
import { fmtTime } from "../format";

export interface DongKb { id: string; ten: string; ownerId: string; ownerName: string | null }
interface KqId { id: string; ten: string | null; ma: string; lyDo: string | null }
interface KetQuaNhieu { ketQua: KqId[]; soOk: number; soLoi: number }
interface KiemId extends KqId { ownerId: string | null; ownerName: string | null; canhBao: string[] }
interface MucThung { id: string; ten: string; nenTang: string; soBuoc: number; ownerId: string; ownerName: string | null; xoaLuc: string; xoaBoiTen: string | null; quaHan: boolean; conNgay: number }
interface DsThung { hanNgay: number; tong: number; soQuaHan: number; items: MucThung[] }

/** Ô xác nhận xoá vĩnh viễn: đúng chữ XOA in hoa (hộp ghi "in hoa" — chữ thường không được nhận). */
export const khopChuXoa = (v: string): boolean => v.trim() === "XOA";
const TOI_DA_TEN = 5;
const q = (s: string): string => `“${s}”`;

function bieuTuongThung(): SVGElement {
  return svg("svg", { viewBox: "0 0 24 24", width: 15, height: 15, fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round", "aria-hidden": "true", class: "kb-xoa-bieu" },
    svg("path", { d: "M3 6h18" }), svg("path", { d: "M8 6V4h8v2" }), svg("path", { d: "M19 6l-1 14H6L5 6" }), svg("path", { d: "M10 11v6M14 11v6" }));
}

/** Câu "“A”, “B”, “C” và N kịch bản khác" — tối đa 5 tên đầu. */
export function cauTen(ten: string[]): string {
  const dau = ten.slice(0, TOI_DA_TEN).map(q).join(", ");
  return ten.length > TOI_DA_TEN ? `${dau} và ${ten.length - TOI_DA_TEN} kịch bản khác` : dau;
}

interface Hop { title: string; than: Node[]; okText: string | null; danger?: boolean; huyText?: string; goXoa?: boolean; testid: string }
/** Hộp thoại của trang (kiểu confirmBox nhưng có nội dung tuỳ ý; okText null = chỉ có nút Đóng). goXoa: nút OK chỉ bật khi gõ đúng chữ XOA. */
function hop(o: Hop): Promise<boolean> {
  return new Promise((resolve) => {
    // (08/10/2026) BẤM ĐÚP nút trong hộp: cú bấm thứ hai (detail ≥ 2) rơi xuống trang dưới hộp vừa đóng — trúng liên kết dòng kịch bản / nút trên dòng
    // (mở nhầm kịch bản khác). Nuốt riêng cú bấm "đúp" đó trong 600 ms sau khi hộp đóng; cú bấm đơn mới (detail 1) vẫn đi bình thường.
    const xong = (v: boolean): void => {
      wrap.remove();
      const t0 = Date.now();
      const nuot = (e: MouseEvent): void => { if (e.detail > 1 && Date.now() - t0 < 600) { e.preventDefault(); e.stopPropagation(); } };
      document.addEventListener("click", nuot, true);
      window.setTimeout(() => document.removeEventListener("click", nuot, true), 600);
      resolve(v);
    };
    const huy = h("button", { type: "button", "data-testid": "kb-xoa-huy", title: "Đóng hộp này, không làm gì cả", onclick: () => xong(false) }, o.huyText ?? (o.okText ? "Huỷ" : "Đóng"));
    const ok = o.okText ? h("button", { type: "button", class: o.danger ? "danger" : "pri", "data-testid": "kb-xoa-ok", title: o.goXoa ? "Bật khi bạn đã gõ đúng chữ XOA" : o.danger ? "Xác nhận — kịch bản vào Thùng rác, khôi phục được trong 30 ngày" : "Xác nhận", onclick: () => xong(true), disabled: !!o.goXoa }, o.okText) : null;
    let go: HTMLInputElement | null = null;
    if (o.goXoa && ok) {
      go = h("input", { type: "text", autocomplete: "off", spellcheck: "false", maxlength: 10, "data-testid": "kb-xoa-go", "aria-label": "Gõ chữ XOA để xác nhận", placeholder: "XOA" });
      go.addEventListener("input", () => { ok.disabled = !khopChuXoa(go!.value); });
      go.addEventListener("keydown", (e) => { if (e.key === "Enter" && !ok.disabled) xong(true); });
    }
    const wrap = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "data-testid": o.testid },
      h("div", { class: "modal kb-xoa-hop" },
        h("h3", {}, o.title), ...o.than,
        go ? h("label", { class: "f kb-xoa-go-nhan" }, h("span", { class: "small" }, "Gõ chữ XOA (in hoa) để xác nhận xoá vĩnh viễn"), go) : null,
        h("div", { class: "row end" }, huy, ok)));
    wrap.addEventListener("keydown", (e) => { if (e.key === "Escape") xong(false); });
    wrap.addEventListener("dong-hop", () => resolve(false)); // L-82: đổi trang → coi như Huỷ
    document.body.appendChild(wrap);
    (go ?? ok ?? huy).focus();
  });
}

const dsLi = (ten: string[], testid: string): HTMLElement => h("ul", { class: "kb-xoa-ds wrap" }, ...ten.slice(0, TOI_DA_TEN).map((t) => h("li", { "data-testid": testid }, q(t))),
  ten.length > TOI_DA_TEN ? h("li", { class: "muted", "data-testid": `${testid}-con` }, `và ${ten.length - TOI_DA_TEN} kịch bản khác`) : null);

export interface QuanLyXoa {
  /** Bọc một dòng danh sách: [ô tick][dòng (liên kết)][nút ⋯]. */
  boc(k: DongKb, neo: HTMLElement, them?: HTMLElement): HTMLElement;
  /** Xoá MỘT dòng (mục "Xoá" của menu "⋯"): hộp xác nhận → Thùng rác → thanh Hoàn tác. */
  xoaDong(k: DongKb): void;
  /** Danh sách vừa tải lại từ đầu → quên dòng + lựa chọn cũ. */
  datLai(): void;
  hangChon: HTMLElement;
  thanhNoi: HTMLElement;
  thanhHoanTac: HTMLElement;
  nutThung: HTMLElement;
  khungThung: HTMLElement;
  capNhatDemThung(): void;
  /** Có thêm dòng chưa tải (nút "Tải hết rồi chọn"). */
  datConThem(v: boolean): void;
  huy(): void;
}

export function taoQuanLyXoa(o: { alive: () => boolean; nguoiDungId: string; laSuper: boolean; chuDangLoc: () => string; taiLai: () => void; taiHet: () => Promise<void> }): QuanLyXoa {
  const dong = new Map<string, { k: DongKb; hang: HTMLElement; cb: HTMLInputElement }>();
  let dangXoa = false;

  // ---- chọn nhiều ----
  const oTatCa = h("input", { type: "checkbox", "data-testid": "kb-chon-tat-ca", "aria-label": "Chọn tất cả kịch bản đang hiện" });
  const demChon = h("span", { class: "small muted", "data-testid": "kb-chon-dem", "aria-live": "polite" });
  const nutTaiHet = h("button", { type: "button", class: "mini", hidden: true, "data-testid": "kb-chon-tai-het", title: "Tải hết các kịch bản chưa hiện rồi chọn tất cả (dọn rác nhanh)" }, "Tải hết rồi chọn");
  const hangChon = h("div", { class: "kb-chon-hang", "data-testid": "kb-chon-hang" }, h("label", { class: "kb-chon-tat-ca" }, oTatCa, h("span", {}, "Chọn tất cả")), demChon, nutTaiHet);
  const dem = h("span", { "data-testid": "kb-thanh-dem" });
  const nutXoaChon = h("button", { type: "button", class: "danger", "data-testid": "kb-xoa-da-chon", title: "Chuyển các kịch bản đã chọn vào Thùng rác (khôi phục được trong 30 ngày)" }, bieuTuongThung(), h("span", {}, "Xoá đã chọn"));
  const nutBoChon = h("button", { type: "button", "data-testid": "kb-bo-chon", title: "Bỏ chọn tất cả" }, "Bỏ chọn");
  const thanhNoi = h("div", { class: "kb-thanh-noi", role: "region", "aria-label": "Thao tác trên kịch bản đã chọn", hidden: true, "data-testid": "kb-thanh-chon" }, dem, nutXoaChon, nutBoChon);

  const daChon = (): DongKb[] => [...dong.values()].filter((x) => x.cb.checked).map((x) => x.k);
  function capNhat(): void {
    const n = daChon().length;
    const tong = dong.size;
    dem.textContent = `Đã chọn ${n}`;
    demChon.textContent = n ? `Đã chọn ${n}/${tong}` : tong ? `${tong} kịch bản đang hiện` : "";
    thanhNoi.hidden = n === 0;
    oTatCa.checked = tong > 0 && n === tong;
    oTatCa.indeterminate = n > 0 && n < tong;
    oTatCa.disabled = tong === 0;
    for (const x of dong.values()) x.hang.classList.toggle("chon", x.cb.checked);
  }
  oTatCa.addEventListener("change", () => { for (const x of dong.values()) x.cb.checked = oTatCa.checked; capNhat(); });
  nutBoChon.addEventListener("click", () => { for (const x of dong.values()) x.cb.checked = false; capNhat(); });
  nutTaiHet.addEventListener("click", () => void (async () => {
    nutTaiHet.disabled = true;
    try { await o.taiHet(); for (const x of dong.values()) x.cb.checked = true; capNhat(); } catch (e) { toast(errMsg(e), "err"); } finally { nutTaiHet.disabled = false; }
  })());

  // ---- xoá (mềm) ----
  const thanhHoanTac = h("div", { class: "kb-ht-xoa", role: "status", "aria-live": "polite", hidden: true, "data-testid": "kb-xoa-hoan-tac-bar" });
  function hienHoanTac(ds: { id: string; ten: string | null }[], loi: string[]): void {
    clear(thanhHoanTac);
    const nutHt = h("button", { type: "button", class: "mini pri", "data-testid": "kb-xoa-hoan-tac", title: "Đưa các kịch bản vừa xoá trở lại danh sách" }, "Hoàn tác");
    const nutDong = h("button", { type: "button", class: "kb-noi-x", "aria-label": "Ẩn thanh Hoàn tác", title: "Ẩn (kịch bản vẫn nằm trong Thùng rác)", "data-testid": "kb-xoa-hoan-tac-dong", onclick: () => { thanhHoanTac.hidden = true; } }, "×");
    thanhHoanTac.append(h("span", { class: "kb-ht-xoa-chu", "data-testid": "kb-xoa-hoan-tac-chu" }, `Đã xoá ${ds.length} kịch bản${ds.length === 1 && ds[0]!.ten ? ` ${q(ds[0]!.ten)}` : ""}`, loi.length ? ` · không xoá được ${loi.length}` : ""), nutHt, nutDong);
    nutHt.addEventListener("click", () => void (async () => {
      if (nutHt.disabled) return;
      nutHt.disabled = true;
      try {
        const r = await api<KetQuaNhieu>("POST", "/api/kich-ban/khoi-phuc-nhieu", { ids: ds.map((x) => x.id) });
        thanhHoanTac.hidden = true;
        toast(`Đã khôi phục ${r.soOk} kịch bản`);
        o.taiLai();
        capNhatDemThung();
      } catch (e) { nutHt.disabled = false; toast(errMsg(e), "err"); }
    })());
    thanhHoanTac.hidden = false;
  }

  async function xoaCacDong(ks: DongKb[]): Promise<void> {
    if (dangXoa || !ks.length) return;
    dangXoa = true;
    try {
      let kiem: KiemId[];
      try { kiem = (await api<{ items: KiemId[] }>("POST", "/api/kich-ban/kiem-xoa", { ids: ks.map((x) => x.id) })).items; } catch (e) { toast(errMsg(e), "err"); return; }
      if (!o.alive()) return;
      const tenCua = (id: string): string => ks.find((x) => x.id === id)?.ten ?? id;
      const ok = kiem.filter((x) => x.ma === "ok");
      const chan = kiem.filter((x) => x.ma === "dang_chay");
      const loiKhac = kiem.filter((x) => x.ma !== "ok" && x.ma !== "dang_chay");
      const canhBao = ok.filter((x) => x.canhBao.length);
      const khacChu = o.laSuper ? [...new Set(ok.filter((x) => x.ownerId && x.ownerId !== o.nguoiDungId && x.ownerName).map((x) => x.ownerName!))] : [];
      const than: Node[] = [];
      if (ok.length) {
        than.push(h("p", { class: "wrap", "data-testid": "kb-xoa-tieu-de" }, ok.length === 1 ? `Chuyển ${q(ok[0]!.ten ?? tenCua(ok[0]!.id))} vào Thùng rác?` : `Chuyển ${ok.length} kịch bản vào Thùng rác?`), dsLi(ok.map((x) => `${x.ten ?? tenCua(x.id)}${o.laSuper && x.ownerId && x.ownerId !== o.nguoiDungId && x.ownerName ? ` — chủ: ${x.ownerName}` : ""}`), "kb-xoa-ten"));
        if (khacChu.length) than.push(h("div", { class: "warn-box", "data-testid": "kb-xoa-khac-chu" }, `Bạn đang xoá kịch bản của Boss khác: ${khacChu.join(", ")}.`));
        than.push(h("p", { class: "small muted wrap", "data-testid": "kb-xoa-ghi-chu" }, "Kịch bản nằm trong Thùng rác 30 ngày, khôi phục được bất cứ lúc nào. Các lần chạy cũ vẫn giữ trong Lịch sử chạy."));
      }
      if (canhBao.length) than.push(h("div", { class: "warn-box wrap", "data-testid": "kb-xoa-canh-bao" }, h("b", {}, "Đang được dùng:"),
        h("ul", {}, ...canhBao.slice(0, TOI_DA_TEN).map((x) => h("li", { "data-testid": "kb-xoa-canh-bao-dong" }, `${q(x.ten ?? tenCua(x.id))}: ${x.canhBao.join("; ")}`)),
          canhBao.length > TOI_DA_TEN ? h("li", {}, `và ${canhBao.length - TOI_DA_TEN} kịch bản khác cũng đang được dùng`) : null)));
      if (chan.length) than.push(h("div", { class: "err-box wrap", "data-testid": "kb-xoa-chan" }, h("b", {}, `${chan.length} kịch bản đang chạy — không xoá được:`),
        h("ul", {}, ...chan.slice(0, TOI_DA_TEN).map((x) => h("li", { "data-testid": "kb-xoa-chan-dong" }, `${q(x.ten ?? tenCua(x.id))}: ${x.lyDo ?? "đang chạy"}`)), chan.length > TOI_DA_TEN ? h("li", {}, `và ${chan.length - TOI_DA_TEN} kịch bản khác`) : null)));
      if (loiKhac.length) than.push(h("div", { class: "err-box wrap", "data-testid": "kb-xoa-loi" }, `${loiKhac.length} kịch bản bỏ qua: ${loiKhac.slice(0, 3).map((x) => `${q(x.ten ?? tenCua(x.id))} — ${x.lyDo ?? x.ma}`).join("; ")}`));
      if (!ok.length) {
        await hop({ title: "Không có kịch bản nào xoá được", than, okText: null, testid: "kb-xoa-hop" });
        return;
      }
      if (!(await hop({ title: "Xoá kịch bản", than, okText: ok.length === 1 ? "Chuyển vào Thùng rác" : `Chuyển ${ok.length} kịch bản vào Thùng rác`, danger: true, testid: "kb-xoa-hop" }))) return;
      if (!o.alive()) return;
      let r: KetQuaNhieu;
      try { r = await api<KetQuaNhieu>("POST", "/api/kich-ban/xoa-nhieu", { ids: ok.map((x) => x.id) }); } catch (e) { toast(errMsg(e), "err"); return; }
      const xong = r.ketQua.filter((x) => x.ma === "ok");
      const hong = r.ketQua.filter((x) => x.ma !== "ok");
      for (const x of xong) { const d = dong.get(x.id); if (d) { d.hang.remove(); dong.delete(x.id); } }
      capNhat();
      if (xong.length) hienHoanTac(xong.map((x) => ({ id: x.id, ten: x.ten })), hong.map((x) => x.lyDo ?? x.ma));
      if (hong.length) toast(`Không xoá được ${hong.length} kịch bản: ${hong.slice(0, 2).map((x) => `${q(x.ten ?? tenCua(x.id))} — ${x.lyDo ?? x.ma}`).join("; ")}`, "warn", 8000);
      capNhatDemThung();
      if (!dong.size) o.taiLai();
    } finally { dangXoa = false; }
  }
  nutXoaChon.addEventListener("click", () => void xoaCacDong(daChon()));

  function boc(k: DongKb, neo: HTMLElement, them?: HTMLElement): HTMLElement {
    const cb = h("input", { type: "checkbox", class: "kb-chon-o", "data-testid": "kb-chon-dong", "aria-label": `Chọn kịch bản ${q(k.ten)}` });
    // `them` (08/10/2026): nút "⋯" + menu Nhân bản / Đổi tên / Xuất / Xoá (kich-ban-dong.ts) — "Xoá" gọi xoaDong() bên dưới
    const hang = h("div", { class: "kb-dong-boc", "data-testid": "kb-dong-boc", dataset: { id: k.id } }, h("label", { class: "kb-chon-nhan-o", title: "Chọn để xoá nhiều kịch bản cùng lúc" }, cb), neo, them ?? null);
    cb.addEventListener("change", capNhat);
    dong.set(k.id, { k, hang, cb });
    capNhat();
    return hang;
  }

  // ---- Thùng rác ----
  const nutThung = h("button", { type: "button", class: "kb-nut-thung", "aria-expanded": "false", "aria-controls": "kb-thung-rac", "data-testid": "kb-thung-rac-nut", title: "Xem kịch bản đã xoá — khôi phục hoặc xoá vĩnh viễn" }, bieuTuongThung(), h("span", { class: "kb-thung-chu" }, "Thùng rác"));
  const khungThung = h("div", { id: "kb-thung-rac", class: "card kb-thung-rac", hidden: true, "data-testid": "kb-thung-rac" });
  let moThung = false;
  let lanThung = 0;
  function datChuNut(tong: number): void { const c = nutThung.querySelector(".kb-thung-chu"); if (c) c.textContent = tong > 0 ? `Thùng rác (${tong})` : "Thùng rác"; }
  function capNhatDemThung(): void {
    void api<DsThung>("GET", `/api/kich-ban?thungRac=1&limit=1${o.chuDangLoc() ? `&ownerId=${encodeURIComponent(o.chuDangLoc())}` : ""}`).then((r) => { if (o.alive()) datChuNut(r.tong); }).catch(() => null);
  }
  async function veThung(): Promise<void> {
    const g = ++lanThung;
    clear(khungThung);
    khungThung.append(h("p", { class: "muted" }, "Đang tải Thùng rác…"));
    let r: DsThung;
    try { r = await api<DsThung>("GET", `/api/kich-ban?thungRac=1&limit=200${o.chuDangLoc() ? `&ownerId=${encodeURIComponent(o.chuDangLoc())}` : ""}`); } catch (e) { if (g === lanThung) { clear(khungThung); khungThung.append(h("div", { class: "err-box" }, `Không tải được Thùng rác: ${errMsg(e)}`)); } return; }
    if (g !== lanThung || !o.alive()) return;
    datChuNut(r.tong);
    clear(khungThung);
    const nutDon = h("button", { type: "button", class: "mini", disabled: r.soQuaHan === 0, "data-testid": "kb-tr-don", title: `Xoá vĩnh viễn các kịch bản đã nằm trong Thùng rác quá ${r.hanNgay} ngày` }, `Dọn thùng rác (${r.soQuaHan} mục quá ${r.hanNgay} ngày)`);
    const nutDongThung = h("button", { type: "button", class: "mini", "data-testid": "kb-tr-dong-khung", title: "Đóng khung Thùng rác (không xoá gì)", onclick: () => doiThung(false) }, "Đóng");
    khungThung.append(h("div", { class: "row between wrap" }, h("h3", {}, `Thùng rác — ${r.tong} kịch bản`), h("div", { class: "row wrap" }, nutDon, nutDongThung)),
      h("p", { class: "small muted" }, `Kịch bản đã xoá nằm đây ${r.hanNgay} ngày; bấm Khôi phục để đưa lại danh sách. Dọn thùng rác chỉ xoá vĩnh viễn những mục đã quá ${r.hanNgay} ngày (không tự động).`));
    if (!r.items.length) khungThung.append(h("p", { class: "empty", "data-testid": "kb-tr-trong" }, "Thùng rác trống."));
    for (const m of r.items) {
      const khoiPhuc = h("button", { type: "button", class: "mini pri", "data-testid": "kb-tr-khoi-phuc", title: "Đưa kịch bản này trở lại danh sách Kịch bản", "aria-label": `Khôi phục kịch bản ${q(m.ten)}` }, "Khôi phục");
      const vinhVien = h("button", { type: "button", class: "mini kb-tr-vinh-vien", "data-testid": "kb-tr-xoa-vinh-vien", title: "Xoá hẳn kịch bản này — không hoàn tác được (phải gõ XOA để xác nhận)", "aria-label": `Xoá vĩnh viễn kịch bản ${q(m.ten)}` }, "Xoá vĩnh viễn");
      const khacChu = o.laSuper && m.ownerName ? ` · chủ: ${m.ownerName}` : "";
      khungThung.append(h("div", { class: "kb-tr-dong", "data-testid": "kb-tr-dong", dataset: { id: m.id } },
        h("span", { class: "kb-dong-ten" }, m.ten),
        h("span", { class: "kb-dong-phu small muted" }, `${m.soBuoc} bước · xoá ${fmtTime(m.xoaLuc)}${m.xoaBoiTen ? ` bởi ${m.xoaBoiTen}` : ""}${khacChu} · ${m.quaHan ? "đã quá hạn" : `còn ${m.conNgay} ngày`}`),
        h("span", { class: "kb-tr-nut" }, khoiPhuc, vinhVien)));
      khoiPhuc.addEventListener("click", () => void (async () => {
        if (khoiPhuc.disabled) return;
        khoiPhuc.disabled = vinhVien.disabled = true;
        try { await api("POST", `/api/kich-ban/${encodeURIComponent(m.id)}/khoi-phuc`); toast(`Đã khôi phục ${q(m.ten)}`); o.taiLai(); await veThung(); } catch (e) { khoiPhuc.disabled = vinhVien.disabled = false; toast(errMsg(e), "err"); if (o.alive()) void veThung(); }
      })());
      vinhVien.addEventListener("click", () => void (async () => {
        if (vinhVien.disabled) return;
        const dongY = await hop({ title: "Xoá vĩnh viễn?", than: [h("p", { class: "wrap" }, `Xoá vĩnh viễn ${q(m.ten)}. Việc này KHÔNG hoàn tác được: sơ đồ các bước sẽ mất hẳn (các lần chạy cũ vẫn giữ trong Lịch sử chạy).`)], okText: "Xoá vĩnh viễn", danger: true, goXoa: true, testid: "kb-xoa-hop" });
        if (!dongY || !o.alive()) return;
        khoiPhuc.disabled = vinhVien.disabled = true;
        try { await api("DELETE", `/api/kich-ban/${encodeURIComponent(m.id)}/vinh-vien`); toast(`Đã xoá vĩnh viễn ${q(m.ten)}`); await veThung(); } catch (e) { khoiPhuc.disabled = vinhVien.disabled = false; toast(errMsg(e), "err"); if (o.alive()) void veThung(); }
      })());
    }
    nutDon.addEventListener("click", () => void (async () => {
      if (nutDon.disabled) return;
      const dongY = await hop({ title: "Dọn thùng rác?", than: [h("p", { class: "wrap" }, `Xoá VĨNH VIỄN ${r.soQuaHan} kịch bản đã nằm trong Thùng rác quá ${r.hanNgay} ngày. Không hoàn tác được.`)], okText: "Dọn thùng rác", danger: true, goXoa: true, testid: "kb-xoa-hop" });
      if (!dongY || !o.alive()) return;
      nutDon.disabled = true;
      try { const k = await api<{ daXoa: number }>("POST", `/api/kich-ban/don-thung-rac${o.chuDangLoc() ? `?ownerId=${encodeURIComponent(o.chuDangLoc())}` : ""}`, {}); toast(`Đã dọn ${k.daXoa} kịch bản quá hạn`); await veThung(); } catch (e) { nutDon.disabled = false; toast(errMsg(e), "err"); }
    })());
  }
  function doiThung(mo: boolean): void {
    moThung = mo;
    khungThung.hidden = !mo;
    nutThung.setAttribute("aria-expanded", mo ? "true" : "false");
    nutThung.classList.toggle("mo", mo);
    if (mo) { void veThung(); khungThung.scrollIntoView({ block: "nearest" }); }
  }
  nutThung.addEventListener("click", () => doiThung(!moThung));
  capNhatDemThung();
  capNhat();

  return {
    boc, xoaDong: (k) => void xoaCacDong([k]), hangChon, thanhNoi, thanhHoanTac, nutThung, khungThung, capNhatDemThung,
    datLai: () => { dong.clear(); capNhat(); },
    datConThem: (v) => { nutTaiHet.hidden = !v; },
    huy: () => { thanhNoi.remove(); thanhHoanTac.remove(); for (const w of document.querySelectorAll('[data-testid="kb-xoa-hop"]')) { w.dispatchEvent(new Event("dong-hop")); w.remove(); } },
  };
}
